
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/typography",
      function () {
        return require("private-next-pages/system/typography.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/typography"])
      });
    }
  